/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Confirmpasswordrequired2Inputs */

const zh_auth_confirmpasswordrequired2 = /** @type {(inputs: Auth_Confirmpasswordrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请确认密码`)
};

const en_auth_confirmpasswordrequired2 = /** @type {(inputs: Auth_Confirmpasswordrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please confirm your password`)
};

const es_auth_confirmpasswordrequired2 = /** @type {(inputs: Auth_Confirmpasswordrequired2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma tu contraseña`)
};

/**
* | output |
* | --- |
* | "Please confirm your password" |
*
* @param {Auth_Confirmpasswordrequired2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_confirmpasswordrequired2 = /** @type {((inputs?: Auth_Confirmpasswordrequired2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Confirmpasswordrequired2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_confirmpasswordrequired2(inputs)
	if (locale === "en") return en_auth_confirmpasswordrequired2(inputs)
	return es_auth_confirmpasswordrequired2(inputs)
});
export { auth_confirmpasswordrequired2 as "auth_confirmPasswordRequired" }